export const metadata = {
  guides: {
    gettingStarted: {
      title: 'Getting Started | Staq Developer Portal',
      description: 'Begin with Staq: A simple guide to integrating innovative digital banking solutions. Start your transformative journey today.'
    },
    sandbox: {
      authentication: {
        title: 'Authentication Guide - Staq Developer Portal',
        description: `Explore the essentials of sandbox authentication on Staq. A must-read for developers aiming for secure, streamlined testing in Staq's environment.`
      },
      applicationsManagement: {
        title: 'Application Management Guide  - Staq Developer Portal',
        description: `Master application management in Staq's sandbox: Learn to acquire access tokens and create apps seamlessly. Essential for developers aiming for efficient API interaction and streamlined sandbox testing.`
      },
      certificatesManagement: {
        title: 'Certificate Management Guide - Staq Developer Portal',
        description: `Learn to generate keys and CSR for Staq API: A step-by-step guide to certificate creation, ensuring data protection with secure API communication.`
      },
      browserCertificateGuide: {
        title: 'Browser Certificate Guide - Staq Developer Portal',
        description: `Learn to integrate certificates in browsers for Staq's Sandbox APIs. Detailed guide on certificate import for Chrome, Windows OS, and more for secure API usage.`
      },
      postmanCertificateGuide: {
        title: 'Postman Certificate Guide - Staq Developer Portal',
        description: `Learn Postman certificate integration in Staq's sandbox with ease. This guide is crucial for developers who want to ensure secure API testing and effective sandbox utilization.`
      }
    },
    webhooks: {
      title: 'Webhooks - Staq Developer Portal',
      description: `Explore Staq's detailed guide on webhook management. Includes step-by-step instructions for Events API & Developer portal UI, ensuring efficient setup for each application.`
    },
    deployments: {
      title: 'Deployments - Staq Developer Portal',
      description: `Explore Staq's detailed guide on deployments. Learn best practices for efficient, reliable application deployment in the Staq ecosystem.`
    }
  },
  apis: {
    identity: {
      title: 'Identity API - Staq Developer Portal',
      description: `Dive into Staq's Identity API with our detailed guide. Includes comprehensive steps for secure integration, ensuring robust identity management in your applications.`
    },
    transfers: {
      title: 'Transfers API - Staq Developer Portal',
      description: `Empower your banking services with Staq's Transfer APIs. Secure, swift money transfers made easy. Learn more.`
    },
    loans: {
      title: `Loan API's Staq Developer Portal`,
      description: `Enhance lending with Staq's Loan APIs: Efficient processing, flexible options, seamless integration. Elevate your banking services now.`
    },
    kyc: {
      title: 'KYC API - Staq Developer Portal',
      description: `Streamline identity verification with Staq's KYC APIs. Achieve compliance, enhance security, and simplify onboarding. Learn more.`
    },
    cards: {
      title: 'Card API - Staq Developer Portal',
      description: `Empower your digital banking services with Staq's Card APIs. Seamlessly integrate card issuing, management, and transaction processing. Elevate your financial solutions today.`
    },
    accounts: {
      title: 'Accounts API - Staq Developer Portal',
      description: `Discover Staq's Accounts API for streamlined account management. Our guide includes detailed integration steps for effective account handling.`
    },
    bnpl: {
      title: 'BNPL API - Staq Developer Portal ',
      description: `Explore the Staq BNPL API for easy Buy Now Pay Later solutions. This guide provides essential integration steps for flexible payment options.`
    },
    disputes: {
      title: 'Disputes API - Staq Developer Portal',
      description: `Navigate dispute management with Staq's Disputes API. Our comprehensive guide covers all you need for effective dispute resolution processes.`
    },
    data: {
      title: 'Data API- Staq Developer Portal',
      description: `Explore Staq's Data API for sophisticated data management. Our guide details seamless integration for robust data analysis and handling.`
    },
    events: {
      title: 'Events API - Staq Developer Portal',
      description: `Master event handling with Staq's Events API. This guide offers comprehensive steps for efficient event management and integration.`
    },
    remittance: {
      title: 'Remittance API - Staq Developer Portal',
      description: `Navigate remittance efficiently with Staq's API. Our guide provides essential steps for streamlined payment & remittance solutions.`
    },
    cliq: {
      title: 'CliQ API - Staq Developer Portal',
      description: `Utilize Staq's Cliq API for seamless management of CliQ aliases and bank account linking in third-party apps. Learn more.`
    },
    files: {
      title: 'Files API - Staq Developer Portal',
      description: `Utilize secure file transfers with Staq's Files API. Ensure safe uploads and content validation using user credentials and scanning session identifiers.`
    },
    simulation: {
      title: 'Simulation API - Staq Developer Portal',
      description: `Create realistic testing scenarios with Staq's Simulation API. Our guide details the process for effective simulation and API testing.`
    }
  },
  sdks: {
    kyc: {
      title: 'KYC - Staq Developer Portal',
      description: `Enhance your digital banking solutions with Staq's KYC SDKs. Streamline customer verification processes and ensure compliance with ease. Learn more.`
    }
  }
};
